<app-ambiente-prueba></app-ambiente-prueba>
<router-outlet></router-outlet>

